import * as z from "zod";
import {
  VisitDetailsField,
  VisitDetailsDateRangeStatus,
} from "@/pages/requests/components/visit-details-form/types";

const PurposeSchema = z.object({
  Id: z.number(),
  PurposeEn: z.string(),
  PurposeAr: z.string(),
  Value: z.string(),
});

const createOptionalCount = (min: number, max: number) =>
  z.coerce
    .number()
    .int("Must be an integer")
    .min(min, { message: `Must be between ${min} and ${max}` })
    .max(max, { message: `Must be between ${min} and ${max}` })
    .optional();

export const VisitDetailsSchemaFormDataSchema = z.object({
  [VisitDetailsField.Purpose]: PurposeSchema,
  [VisitDetailsField.From]: z.union([z.date(), z.string()]),
  [VisitDetailsField.To]: z.union([z.date(), z.string()]),
  [VisitDetailsField.DateRange]: z
    .enum([
      VisitDetailsDateRangeStatus.Valid,
      VisitDetailsDateRangeStatus.InvalidRange,
      VisitDetailsDateRangeStatus.EndBeforeStart,
    ])
    .refine(
      val => val === VisitDetailsDateRangeStatus.Valid,
      val => ({
        message: {
          [VisitDetailsDateRangeStatus.EndBeforeStart]:
            "End date cannot be earlier than start date.",
          [VisitDetailsDateRangeStatus.InvalidRange]:
            "Date range cannot be longer than 1 year.",
          [VisitDetailsDateRangeStatus.Valid]: "",
        }[val],
      }),
    ),
  [VisitDetailsField.NumbersGeneral]: z.boolean().refine(value => value),
  [VisitDetailsField.NumberOfVehicles]: createOptionalCount(0, 999999),
  [VisitDetailsField.NumberOfCameras]: createOptionalCount(0, 999999),
  [VisitDetailsField.NumberOfVessels]: createOptionalCount(0, 999999),
});

export const VisitDetailsSchema = z.object({
  [VisitDetailsField.Purpose]: z.array(PurposeSchema).default([]),
});
